import { api } from "@/api";

import { QueryProps } from "@/types/Api";

export interface QueryParams {}

export const getSuspendedMatches = async (
  props: QueryProps<QueryParams>
): Promise<number[]> => {
  const res = await api.client.get(`/matches/suspended`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
